import {yupResolver} from '@hookform/resolvers/yup'
import Button, {ButtonProps} from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import {IBusiness} from 'app/modules/discovery/core'
import React from 'react'
import {useForm} from 'react-hook-form'
import {useStylesCommon} from 'styles/useStyles'
import * as yup from 'yup'

interface StarterInfo {
  first_name: string
  last_name: string
  email: string
  phoneNumber?: string
  orgName?: string
  employer?: IBusiness
  accountType?: 'free|single|standard|premium'
}

interface Props {
  submitButtonRef?: React.Ref<HTMLButtonElement>
  loading?: boolean
  submitButtonProps?: ButtonProps
  goToNextStep?: () => void
  initialValues?: StarterInfo
  onSubmit?: (data: any) => void
}
const schema = yup
  .object({
    firstName: yup.string().required('*First Name is required'),
    lastName: yup.string().required('*First Name is required'),
    email: yup.string().email().required('*Email address is required'),
  })
  .required()

export default function BasicInfoForm({
  submitButtonRef,
  submitButtonProps,
  loading,
  goToNextStep,
  initialValues,
  onSubmit,
}: Props) {
  const classes = useStylesCommon()
  const [accountType, setAccountType] = React.useState<string>('')
  const {
    register,
    handleSubmit,
    control,
    formState: {errors, isSubmitting},
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      phoneNumber: initialValues?.phoneNumber ?? '',
      firstName: initialValues?.first_name ?? '',
      lastName: initialValues?.last_name ?? '',
      email: initialValues?.email ?? '',
      orgName: initialValues?.employer?.name ?? '',
      accountType: initialValues?.accountType ?? '',
    },
  })

  const onSubmitForm = handleSubmit((data) => {
    //use parent onSubmit, this form used in multiple places
    onSubmit && onSubmit(data)
    goToNextStep && goToNextStep()
  })

  return (
    <form autoComplete='off' onSubmit={onSubmitForm}>
      <Grid container></Grid>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <>
            <TextField
              fullWidth
              variant='outlined'
              defaultValue={initialValues?.first_name ?? ''}
              autoCapitalize='off'
              label='First Name'
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              disabled={isSubmitting}
              helperText={<>{errors.firstName?.message ?? ''}</>}
              {...register('firstName')}
            />
          </>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            variant='outlined'
            defaultValue={initialValues?.last_name ?? ''}
            autoCapitalize='off'
            label='Last Name'
            FormHelperTextProps={{
              className: classes.helperText,
            }}
            disabled={isSubmitting}
            helperText={<>{errors.lastName?.message ?? ''}</>}
            {...register('lastName')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant='outlined'
            defaultValue={initialValues?.email ?? ''}
            autoCapitalize='off'
            FormHelperTextProps={{
              className: classes.helperText,
            }}
            helperText={<>{errors.email?.message ?? ''}</>}
            label='Email'
            {...register('email')}
          />
        </Grid>
        {/* <Grid item xs={6}>
          <Controller
            render={({field}) => (
              <MuiPhoneNumber
                variant={'outlined'}
                fullWidth
                label={'Phone Number'}
                defaultCountry={'us'}
                {...field}
              />
            )}
            defaultValue={initialValues?.phoneNumber ?? ''}
            name={'phoneNumber'}
            control={control}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            variant='outlined'
            defaultValue={initialValues?.employer?.name ?? ''}
            autoCapitalize='off'
            label='Organization Name'
            {...register('orgName')}
          />
        </Grid> */}
        {/* <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel id='account-select-label'>Request Account Type</InputLabel>
            <Select
              labelId='account-select-label'
              id='account-select'
              value={accountType}
              label='Select Account Type'
              {...register('accountType', {
                onChange: (event) => setAccountType(event.target.value),
              })}
            >
              <MenuItem value={'Free'}>{'Free'}</MenuItem>
              <MenuItem value={'Single'}>{'Single'}</MenuItem>
              <MenuItem value={'Standard'}>{'Standard'}</MenuItem>
              <MenuItem value={'Premium'}>{'Premium'}</MenuItem>
            </Select>
            <FormHelperText>
              <span className={classes.validationTextError}>
                {errors.accountType?.message ?? ''}
              </span>
            </FormHelperText>
          </FormControl>
        </Grid> */}
        <Button
          variant='contained'
          color='primary'
          type='submit'
          disabled={loading}
          {...submitButtonProps}
          ref={submitButtonRef}
        >
          {submitButtonProps?.children ?? 'Submit'}
        </Button>
      </Grid>
    </form>
  )
}
